export const onRowSelectedEvent = ({params, onRowSelected }) => {
  if(onRowSelected) onRowSelected(params);
}